import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import AwooGeneral from "./components/awoo/awooadmin/awoogeneral";
import AwooProductos from "./components/awoo/awooadmin/awooproductos";
import AwooRegistro from "./components/awoo/awooadmin/awooregistro";
import AwooVistaItem from "./components/awoo/awooadmin/awoovistaitem";
import AwooRendimiento from "./components/awoo/awooadmin/awoorendimiento";
import AwooCodigoIntermitente from "./components/awoo/awooadmin/awoocodigo";
import AwooClienteRecurrentes from "./components/awoo/awooadmin/awooclientesrecurrentes";
import AwooPedidoInterfaz from "./components/awoo/awooadmin/awoopedidointerfaz";
import Fyrion3dinventario from "./components/awoo/awooadmin/3dfyrioninventario";
import Fyrion3dBodega from "./components/awoo/awooadmin/3dfyrionbodega";

import Fyrion3dSuccess from "./components/awoo/awooadmin/3dfyrionsuccess";
import Fyrion3dFailure from "./components/awoo/awooadmin/3dfyrionfailure";
import Fyrion3dPending from "./components/awoo/awooadmin/3dfyrionpending";


import AppTabs from "./components/awoo/awooadmin/AppTabs";
import FyrionInicio from "./components/awoo/awooadmin/3dfyrioninicio";
import FyrionInicioProductos from "./components/awoo/awooadmin/3dfyrioninicioproductos";
import FyrionInicioOfertas from "./components/awoo/awooadmin/3dfyrioninicioofertas";
import FyrionInicioSimulacion from "./components/awoo/awooadmin/3dfyrioniniciosimulacion";
import FyrionVista from "./components/awoo/awoousuarios/3dfyrionvista";
import FyrionPrueba3d from "./components/awoo/awoousuarios/3dfyrionstlprueba";
import FyrionVisorRealidad from "./components/awoo/awoousuarios/3dfyrionvisor";
import FyrionVisorConector from './components/awoo/awoousuarios/arviewer';
import Fyrionstlplacas from './components/awoo/awoousuarios/3dfyrionstlplacas';
import Fyrionstlnombres from './components/awoo/awoousuarios/3dfyrionstlnombres';
import Fyriontonoysaturacion from './components/awoo/awoousuarios/3dfyriontonoysaturacion';
import Fyrionnombrelampara from './components/awoo/awoousuarios/3dfyrionnombrelampara';
import Fyriondibujolampara from './components/awoo/awoousuarios/3dfyriondibujolampara';
import Fyriondibujolamparasimulacion from './components/awoo/awoousuarios/3dfyriondibujolamparasimulacion';
import Fyrionrepararstl from './components/awoo/awoousuarios/3dfyrionrepararstl';
import Fyrion3dControlGranja1 from "./components/awoo/awoousuarios/3dfyrioncontrolgranja1";
import Fyrion3dMaker from "./components/awoo/awoousuarios/3dfyrionmaker";
import Fyrion3dLetreroDiseno from "./components/awoo/awoousuarios/3dfyrionletrerodiseño";
import Fyrion3dLetreroDisenoCurvo from "./components/awoo/awoousuarios/3dfyrionletrerodiseñocurvo";
import Fyrion3dReductorStl from "./components/awoo/awoousuarios/3dfyrionreductorstl";



import AwooBar from "./components/awoo/awooservicios/awoobar";
import AwooCocina from "./components/awoo/awooservicios/awoococina";
import AwooGranizados from "./components/awoo/awooservicios/awoogranizados";

import AwooLogo from "./components/awoo/awoousuarios/awoologo";
import AwooMesaQR from "./components/awoo/awoousuarios/awoomesaqr";
import AwooInicioUsuarios from "./components/awoo/awoousuarios/awooiniciousuarios";
import AwooProductosUsuario from "./components/awoo/awoousuarios/awooproductosusuario";
import Fyrion3dResumen from "./components/awoo/awoousuarios/3dfyrionresumen";
import Fyrion3dCheckout from "./components/awoo/awoousuarios/3dfyrioncheckout";

import SlicerUploader from "./components/awoo/awoousuarios/SlicerUploader";

import { UserProvider } from "./components/UserContext";

function App() {
  return (
    <div className="App">
      

      <Router>
        {/* Coloca el UserProvider aquí */}

        <UserProvider>
          <Routes>
            <Route path="/" element={<AppTabs />} />

        <Route path="/:categoria/:producto" element={<FyrionVista />} />
        

            <Route path="/awoogeneral" element={<AwooGeneral />} />
            <Route path="/awooproductos" element={<AwooProductos />} />
            <Route path="/awooregistro" element={<AwooRegistro />} />
            <Route path="/awoovistaitem" element={<AwooVistaItem />} />
            <Route path="/awoorendimiento" element={<AwooRendimiento />} />
            <Route path="/awoocodigo" element={<AwooCodigoIntermitente />} />
            <Route path="/awooclientesrecurrentes" element={<AwooClienteRecurrentes />} />
            <Route path="/awoopedidointerfaz" element={<AwooPedidoInterfaz />} />
            
            
            <Route path="/3dfyrioninicioofertas" element={<FyrionInicioOfertas />} />

            <Route path="/3dfyrionvista" element={<FyrionVista />} />
            <Route path="/3dfyrionstlprueba" element={<FyrionPrueba3d />} />
            <Route path="/3dfyrionvisor" element={<FyrionVisorRealidad />} />
            <Route path="/arviewer" element={<FyrionVisorConector />} />
            <Route path="/3dfyrionstlplacas" element={<Fyrionstlplacas />} />
            <Route path="/3dfyrionstlnombres" element={<Fyrionstlnombres />} />
            <Route path="/3dfyriontonoysaturacion" element={<Fyriontonoysaturacion />} />
            <Route path="/3dfyrionnombrelampara" element={<Fyrionnombrelampara />} />
            <Route path="/3dfyriondibujolampara" element={<Fyriondibujolampara />} />
            <Route path="/3dfyriondibujolamparasimulacion" element={<Fyriondibujolamparasimulacion/>} />
            <Route path="/3dfyrionrepararstl" element={<Fyrionrepararstl />} />
            <Route path="/3dfyrioncontrolgranja1" element={<Fyrion3dControlGranja1 />} />
            <Route path="/3dfyrionmaker" element={<Fyrion3dMaker />} />
            <Route path="/3dfyrionletrerodiseño" element={<Fyrion3dLetreroDiseno />} />
            <Route path="/3dfyrionletrerodiseñocurvo" element={<Fyrion3dLetreroDisenoCurvo />} />
            <Route path="/3dfyrionreductorstl" element={<Fyrion3dReductorStl />} />
            <Route path="/3dfyrioninventario" element={<Fyrion3dinventario/>} />
            <Route path="/3dfyrionbodega" element={<Fyrion3dBodega/>} />
            
            <Route path="/3dfyrionsuccess" element={<Fyrion3dSuccess/>} />
            <Route path="/3dfyrionfailure" element={<Fyrion3dFailure/>} />
            <Route path="/3dfyrionpending" element={<Fyrion3dPending/>} />
            
            <Route path="/awoobar" element={<AwooBar />} />
            <Route path="/awoococina" element={<AwooCocina />} />
            <Route path="/awoogranizados" element={<AwooGranizados />} />
            
            <Route path="/awoologo" element={<AwooLogo />} />
            <Route path="/awoomesaqr" element={<AwooMesaQR />} />
            <Route path="/awooiniciousuarios" element={<AwooInicioUsuarios />} />
            <Route path="/awooproductosusuario" element={<AwooProductosUsuario />} />
            <Route path="/3dfyrionresumen" element={<Fyrion3dResumen />} />
            <Route path="/3dfyrioncheckout" element={<Fyrion3dCheckout />} />

   {/* Ruta para manejar páginas no encontradas */}
   <Route path="*" element={<AwooGeneral />} /> {/* Puedes crear un componente 404 personalizado */}
        

          </Routes>
        </UserProvider>
      </Router>
    </div>
  );
}

export default App;
